import $ from 'jquery';

(function() {
  var $refresher = $('.js-refresher');

  if ($refresher.length) {
    setTimeout(function() {
      location.reload();
    }, 30000);
  }
})($);



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/refresher.js
 **/